export const concurso = [
	
	{
		"nombre": "Concurso de Transparencia",
		"imagen": 'noticias/derechosautor.jpg',
	   "funcion": 'Derechos de Autor',
		"url" : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Tutoriales/derechos%20de%20autor.mp4',
	},
	{
		"nombre": "Concurso de Transparencia",
		"imagen": 'noticias/herramientasvideo.jpg',
	   "funcion": 'Herramientas de Videos',
		"url" : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Tutoriales/Herramientas_videos.mp4',
    },
	{
		"nombre": "Concurso de Transparencia",
		"imagen": 'noticias/tipscomposicion.jpg',
	   "funcion": 'Tips Composición',
		"url" : 'https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Tutoriales/Tips_Composicion.mp4',
	}

	
	// {
	// 	"nombre": " Padrón de Empresas Íntegras",
	// 	"imagen": 'noticias/Empresas.jpg',
	//    "funcion": '"25 de Enero"',
	// 	"url" : 'https://www.facebook.com/watch/?v=1347448829582233&vanity=SecretariaContraloriaHgo&_rdr',
	// },
	// {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]